import { ComponentType, ReactNode } from 'react';
import { GraphQLTaggedNode, QueryRenderer, Variables, useRelayEnvironment } from 'react-relay';

import { Loading } from '@feedback/ui';

// import { getQueryName } from '../ssr/ssr';

import FailureView from './FailureView';

type Config = {
  query: GraphQLTaggedNode;
  queriesParams?: ((props: Record<string, unknown>) => object) | undefined;
  variables?: Variables;
  loadingView?: ReactNode;
  fetchPolicy?: string;
  getFragmentProps?: (fragmentProps: Record<string, unknown>) => object;
};

export default function createQueryRendererModern(
  FragmentComponent: ComponentType,
  config: Config,
): ComponentType {
  const { query, queriesParams } = config;

  const QueryRendererWrapper = (wrapperProps) => {
    const environment = useRelayEnvironment();

    const variables = queriesParams
      ? queriesParams(wrapperProps)
      : config.variables;

    return (
      <QueryRenderer
        environment={environment}
        query={query}
        variables={variables}
        fetchPolicy={config.fetchPolicy || 'store-or-network'}
        render={({ error, props, retry }) => {
          if (props) {
            const fragmentProps = config.getFragmentProps
              ? config.getFragmentProps(props)
              : { query: props };

            return <FragmentComponent {...wrapperProps} {...fragmentProps} />;
          }

          if (error) {
            return <FailureView error={error} retry={retry} />;
          }

          if (config.loadingView) {
            return config.loadingView;
          }

          return <Loading fullScreen={true} />;
        }}
      />
    );
  };

  return QueryRendererWrapper;
}
